// extracted by mini-css-extract-plugin
module.exports = {"Dropping":"Dropping--15IbR","Tab":"Tab--1iveG"};